interface Props {
  situacion: string;
}

export default function EmptyProtocolState({ situacion }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-background-200 flex items-center justify-center mb-5">
        <i className="ri-file-unknow-line text-foreground-400 text-2xl" />
      </div>
      <h3 className="text-lg font-semibold text-foreground-900 mb-2">
        No hay información suficiente para construir el protocolo
      </h3>
      <p className="text-sm text-foreground-500 max-w-md mb-2">
        No encontré respaldo suficiente en la documentación cargada para entregar pasos de actuación seguros.
      </p>
      {situacion && (
        <p className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-lg mb-6">
          Situación consultada: <span className="font-medium text-foreground-600">{situacion}</span>
        </p>
      )}
      <div className="flex flex-wrap gap-2 justify-center">
        <button className="flex items-center gap-1.5 text-xs font-medium text-primary-600 bg-primary-50 hover:bg-primary-100 px-3.5 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-folder-open-line" />
          Revisar documentos cargados
        </button>
        <button className="flex items-center gap-1.5 text-xs font-medium text-secondary-600 bg-secondary-50 hover:bg-secondary-100 px-3.5 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-user-voice-line" />
          Consultar al responsable institucional
        </button>
        <button className="flex items-center gap-1.5 text-xs font-medium text-amber-600 bg-amber-50 hover:bg-amber-100 px-3.5 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-flag-line" />
          Marcar como vacío normativo
        </button>
        <button className="flex items-center gap-1.5 text-xs font-medium text-foreground-500 bg-background-100 hover:bg-background-200 px-3.5 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-upload-cloud-line" />
          Solicitar actualización del reglamento
        </button>
      </div>
    </div>
  );
}